import { IPalletAdvancedSettings } from 'src/app/models_new/types/pallet-advanced-settings';
import { settings } from '../application-settings';

export const defaultAdvancedSettings: IPalletAdvancedSettings = {
  altLayout: settings.defaultAltLayout,
  activeViewPallets: [settings.primaryPallet],
  stackingMethod: settings.defaultStackingMethod,
};
